
import qs from 'qs'
import {Toast} from 'vant'
import $ from 'jquery'

export default {
  name: 'newprogram',
  data() {
    return {
      programNameIndex: 0,  //节目名称
      programgroupName: '', //节目分组名称
      programName: `pro-${new Date().getFullYear()}${new Date().getMonth() + 1}${new Date().getDate()}${new Date().getHours()}${new Date().getMinutes() + 1}${new Date().getSeconds()}`,  //节目名称
      showPicker: false,
      groupingList: [],
      showresolution: false,
      resolutions: [],
      resolution: '',
      resolutionIndex: 0,
      resolutionType: 2,
      fixedScreen: 1,

    }
  },
  mounted() {
    this.$nextTick(() => {
      var winHeight = $(window).height()
      $(window).resize(function () {
        var thisWidth = $(this).height()
        if (winHeight > thisWidth) {
          $('.van-tabbar').hide()
        } else {
          $('.van-tabbar').show()
        }
      })
    })

    this.createprogram()
  },
  methods: {
    onConfirm(value, index) {
      this.showPicker = false
      this.programgroupName = value
      this.programNameIndex = index
    },

    createprogram() {
      this.$ajax.post('/etv/selectProgramCategoryAll.json').then(res => {
        if (res.data.code === 0) {
          this.groupingList = res.data.data
          this.programgroupName = res.data.data[0].name
        }
      })
      this.$ajax.post('/etv/selectAllResolution.json').then(res => {
        if (res.data.code === 0) {
          this.resolutions = res.data.data
          this.resolution = res.data.data[0].ruLPixel + '*' + res.data.data[0].ruWPixel
        }
      })
    },
    onprogramShow() {

      if (this.programName === '') {
        Toast(this.$t('append_field.enter_program_name'))
        return
      }

      this.$ajax.post('/etv/selectProgramMouldNameExist.json', qs.stringify({
        name: this.programName,
        pcId: this.groupingList[this.programNameIndex].id,
      })).then(res => {
        if (this.resolutionType ===2) {
          if (this.fixedScreen === 1) {
            this.resolution = '1920*1080'
          } else if (this.fixedScreen === 2) {
            this.resolution = '1080*1920'
          }
        }
        if (res.data.code === 0) {
          this.$ajax({
            url: '/etv/insertProgramMouldInfo.json',
            method: 'post',
            data: {
              pcId: this.groupingList[this.programNameIndex].id,
              name: this.programName,
              type: '1',
              resolution: this.resolution,
              platform: 'phone',
              resolutionType: this.resolutionType,
              fixedScreen: this.fixedScreen
            },
          }).then(res => {
            if (res.data.code === 0) {
              this.$router.push({
                path: '/createProrram',
                query: {
                  id: res.data.data.pmId,
                },
              })
            } else {
              Toast(res.data.msg)
            }
          })
        } else {
          Toast(res.data.msg)
        }
      })
    },
    getresolution(value) {
      this.showresolution = false
      this.resolution = value
    },
  },
}
